import React, { memo, useState, useEffect } from 'react';
import { ToolbarButtons } from './Toolbar.Styles';
import { ToolbarButton } from './ToolbarButton';
import { Link, UnLink } from './Icons';
import { EditorState, RichUtils, Modifier, SelectionState } from 'draft-js';
import { LinkField } from './LinkField';
export var LinkControls = memo(function (_a) {
    var onToggle = _a.onToggle, editorState = _a.editorState, bg = _a.bg;
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var selectionIsCollapsed = selection.isCollapsed();
    var startKey = selection.getStartKey();
    var startOffset = selection.getStartOffset();
    var currentContentBlock = contentState.getBlockForKey(startKey);
    var linkKey = currentContentBlock.getEntityAt(startOffset);
    var linkInstance = linkKey ? contentState.getEntity(linkKey) : undefined;
    var isLink = linkInstance ? linkInstance.getType() === 'LINK' : false;
    var url = linkInstance && isLink ? linkInstance.getData().url : '';
    var _b = useState(false), showLinkField = _b[0], setShowLinkField = _b[1];
    useEffect(function () {
        if (!isLink && showLinkField)
            setShowLinkField(false);
    }, [isLink]);
    var showField = function () {
        if (isLink || !selectionIsCollapsed)
            setShowLinkField(true);
    };
    var removeLink = function () {
        currentContentBlock.findEntityRanges(function (charData) {
            var entityKey = charData.getEntity();
            if (!entityKey)
                return false;
            return entityKey === linkKey;
        }, function (start, end) {
            var entitySelection = new SelectionState({
                anchorKey: currentContentBlock.getKey(),
                focusKey: currentContentBlock.getKey(),
                anchorOffset: start,
                focusOffset: end
            });
            var newEditorState = EditorState.acceptSelection(editorState, entitySelection);
            newEditorState = EditorState.forceSelection(newEditorState, newEditorState.getSelection());
            newEditorState = RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), null);
            onToggle(newEditorState);
        });
    };
    var onSubmitLink = function (changedURL) {
        if (linkKey && selectionIsCollapsed && isLink) {
            currentContentBlock.findEntityRanges(function (charData) {
                var entityKey = charData.getEntity();
                if (!entityKey)
                    return false;
                return entityKey === linkKey;
            }, function (start, end) {
                var entitySelection = new SelectionState({
                    anchorKey: currentContentBlock.getKey(),
                    focusKey: currentContentBlock.getKey(),
                    anchorOffset: start,
                    focusOffset: end
                });
                var newEditorState = EditorState.acceptSelection(editorState, entitySelection);
                newEditorState = EditorState.forceSelection(newEditorState, newEditorState.getSelection());
                var contentStateWithEntity = contentState.replaceEntityData(linkKey, { url: changedURL });
                newEditorState = EditorState.push(newEditorState, contentStateWithEntity, 'apply-entity');
                onToggle(newEditorState);
            });
        }
        else {
            var contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url: changedURL });
            var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
            var contentStateWithLink = Modifier.applyEntity(contentStateWithEntity, editorState.getSelection(), entityKey);
            var newEditorState = EditorState.push(editorState, contentStateWithLink, 'apply-entity');
            onToggle(newEditorState);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ToolbarButtons, null,
            React.createElement(ToolbarButton, { active: isLink, disabled: !isLink && selectionIsCollapsed, label: React.createElement(Link, null), onToggle: showField, style: "", blockBg: bg }),
            React.createElement(ToolbarButton, { active: false, disabled: !isLink, label: React.createElement(UnLink, null), onToggle: removeLink, style: "", blockBg: bg })),
        showLinkField && React.createElement(LinkField, { url: url, onSubmit: onSubmitLink, onCancel: removeLink })));
});
